import { defineMessages } from 'react-intl'

export default defineMessages({
  EmailPlaceholder: {
    id: 'components.LoginDrawer.EmailPlaceholder',
    defaultMessage: 'Enter the email you save',
    description: '请修改',
  },
  Send: {
    id: 'components.LoginDrawer.Send',
    defaultMessage: 'Send',
    description: '请修改',
  },
  button: {
    id: 'components.LoginDrawer.button',
    defaultMessage: 'Save Card',
    description: '请修改',
  },
  yourPhoneNumber:{
    id: 'components.LoginDrawer.yourPhoneNumber',
    defaultMessage:'Your Phone Number',
    description:'请修改'
  },
  reason:{
    id: 'components.LoginDrawer.reason',
    defaultMessage:'We will need your phone number to verify your account.',
    description:'请修改'
  }
})
